import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import CRUDusuario from "./CRUDusuario";
import { Usuario } from "./contexto/ClasesGrales";
import buscador from "./img/buscador.png";
import { bkCabGrilla, bkCeldaGrilla, bkSeleccion, clCabGrilla, clCeldaGrilla, sizeCabezal, sizeCelda, bbottomGrilla } from "./general.js";
import add from "./img/add.png";

export default function Usuarios() {
  let { firebase } = useContext(AppContext);

  const [usuarios, setUsuarios] = useState(firebase.dataUsuarios);
  const [usuario, setUsuario] = useState(new Usuario());
  const [crudUsuario, setCrudUsuario] = useState(false);
  const [filtroBusqueda, setFiltroBusqueda] = useState("");
  const [filtro, setFiltro] = useState(false)

  useEffect(() => {
    setUsuarios(firebase.usuarios(filtroBusqueda));
  }, [firebase, filtroBusqueda]);

  return (
    <div style={SUsuarios}>
      <div style={SDatosUsuario}>
        <div style={Sbuscador}>
          <img src={buscador} height="30px" width="30px" alt="?" style={{ cursor: "pointer" }} onClick={() => setFiltro(!filtro)} />
          <input
            id="filtro"
            type="text"
            size="50"
            disabled={!filtro}
            style={{ height: "30px", marginLeft: "10px", display: filtro ? "block" : "none" }}
            autoComplete="off"
            onChange={() => setFiltroBusqueda(document.getElementById("filtro").value)}
          ></input>
        </div>

        <Cabezal />
        <div id="grillaUsuarios" style={SGrillaUsuarios}>
          {usuarios.map((u, ind) => (
            <div
              id={u.id}
              style={SLineaUsuario}
              key={u.id}
              onClick={() => {
                setUsuario(u);
                setCrudUsuario(!crudUsuario);

              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = bkSeleccion)}
              onMouseLeave={(e) => (e.currentTarget.style.background = bkCeldaGrilla)}
            >
              <div style={Scelda}>{u.id}</div>
              <div style={Scelda}>{u.nombre}</div>
              <div style={Scelda}>{u.email}</div>
              <div style={Scelda}>{u.horassemana}</div>
              <div style={Scelda}>{u.rol}</div>
            </div>
          ))}
        </div>
        <div style={Sadd}>
          <img
            src={add}
            alt="+"
            title="Agregar"
            height="30px"
            width="30px"
            style={{ display: "block", cursor: "pointer", marginTop: "10px" }}
            onClick={() => {
              setUsuario(new Usuario());
              setCrudUsuario(!crudUsuario);
            }}
          ></img>
        </div>
      </div>
      <div style={Scrud}>
        <div style={SInputUsuario}>{crudUsuario && <CRUDusuario setUsuario={setUsuario} usuario={usuario} set={setCrudUsuario} />}</div>
        <div style={SFoto}>
          <img src={usuario.url} alt="?" height="140px" width="140px" />
        </div>
      </div>
    </div>
  );
}

const SUsuarios = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  width: "93.5vw",
  marginTop: "15px"
};

const SDatosUsuario = {
  width: "53%",
}

const Scrud = {
  width: "38%",
  marginTop: "45px"
}

const Sbuscador = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  marginBottom: "10px"
};

const SGrillaUsuarios = {
  height: "68vh",
  overflowY: "auto",
  marginTop: "6px",
  cursor: "pointer"
};

const SInputUsuario = {
  height: "52vh",
};

const SFoto = {
  height: "140px",
  width: "140px",
  backgroundSize: "cover",
  margin: "auto",
  clipPath: "circle(50%)",
};

const SLineaUsuario = {
  display: "grid",
  gridTemplateColumns: "8% 34% 33% 8% 16%",
  marginBottom: "2px",
  background: bkCeldaGrilla,
  height: "6.3vh",
  overflow: "hidden"
};

const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "8px 2px 8px 2px",
  fontSize: sizeCelda,
  color: clCeldaGrilla
};

const Scabezal = {
  fontSize: sizeCabezal,
  fontWeight: "700",
  background: bkCabGrilla,
  color: clCabGrilla,
  padding: "8px 0px 8px 0px",
};

const ScabezalGrilla = {
  display: "grid",
  gridTemplateColumns: "8% 34% 33% 8% 13%",
  marginLeft: "5px",
};

const Sadd = {
  display: "flex",
  justifyContent: "flex-start",
};

function Cabezal() {
  return (
    <div style={Scabezal}>
      <div style={ScabezalGrilla}>
        <div>Id</div>
        <div>Nombre</div>
        <div>Email</div>
        <div>Horas</div>
        <div>Rol</div>
      </div>
    </div>
  );
}
